import {
  getCurrentFinancialYear,
  normalizeFinancialYearKey,
} from "../tax-planning/taxPlanning";

export { normalizeFinancialYearKey };

/** Parse company serviceCommencesOn → calendar year, or null. */
export function getServiceCommenceYear(companyData) {
  const raw = companyData?.serviceCommencesOn;
  if (!raw) return null;
  const d = new Date(raw);
  if (Number.isNaN(d.getTime())) return null;
  return d.getFullYear();
}

/**
 * Build Indian FY labels from a start calendar year through current FY.
 * If Service Commences On is Jan 2021 → first FY is 2020-2021 (Apr–Mar spanning that year)
 * or 2021-2022 if we start from calendar year as FY start?
 *
 * Product: "Service Commenced year is 2021, so from 2021-22 till current FY"
 * → start FY = `${year}-${year+1}` for calendar year Y.
 */
export function buildFinancialYearOptions(serviceCommenceYear, now = new Date()) {
  const currentFy = getCurrentFinancialYear(now);
  const curStart = Number(String(currentFy).split("-")[0]);
  const startYear =
    Number.isFinite(serviceCommenceYear) && serviceCommenceYear > 1900
      ? serviceCommenceYear
      : curStart;

  const from = Math.min(startYear, curStart);
  const to = Math.max(startYear, curStart);
  const options = [];
  for (let y = from; y <= to; y += 1) {
    options.push(`${y}-${String((y + 1) % 100).padStart(2, "0")}`);
  }
  return options;
}

export function normalizeLockedTaxYears(raw) {
  if (Array.isArray(raw)) {
    return [...new Set(raw.map((y) => String(y).trim()).filter(Boolean))];
  }
  if (typeof raw === "string" && raw.trim()) {
    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) return normalizeLockedTaxYears(parsed);
    } catch {
      return [raw.trim()];
    }
  }
  return [];
}

export function isFinancialYearLocked(fy, { lockedTaxYears = [], taxYear, isTaxYearLocked } = {}) {
  const yearKey = normalizeFinancialYearKey(fy);
  if (!yearKey) return false;
  const locked = normalizeLockedTaxYears(lockedTaxYears).map(normalizeFinancialYearKey);
  if (locked.includes(yearKey)) return true;
  if (
    isTaxYearLocked &&
    taxYear &&
    normalizeFinancialYearKey(taxYear) === yearKey
  ) {
    return true;
  }
  return false;
}

export function readCompanyDataFromStorage() {
  try {
    if (typeof localStorage === "undefined") return null;
    const raw = localStorage.getItem("companyData");
    if (!raw) return null;
    return typeof raw === "string" ? JSON.parse(raw) : raw;
  } catch {
    return null;
  }
}
